const classPrefix = 'services';
const dataPrefix  = 'data-services';

const $container = document.querySelector(`[${dataPrefix}]`);
if ($container) {
    services();
}

export function services() {

}
